import { Injectable } from '@angular/core';
import { CommonConstant } from '@app/common/constant/common.constant';

declare const getInstanceModal: any;
declare const initModal: any;
declare const isShowBootstrap: any;
declare const openOffcanvas: any;
declare const closeOffcanvas: any;
declare const hideCollapse: any;

@Injectable({
    providedIn: 'root'
})
export class BootstrapService {

    constructor() { }

    private InstantModal(id: string) {
        return getInstanceModal(CommonConstant.SHARP + id);
    }

    private InitModal(id: string) {
        return initModal(CommonConstant.SHARP + id);
    }

    private isShowBootstrap(id: string) {
        return isShowBootstrap(CommonConstant.SHARP + id);
    }

    closeModal(id: string) {
        this.InstantModal(id).hide();
    }

    openModal(id: string) {
        if (this.InstantModal(id) !== null) {
            this.InstantModal(id).show();
        } else {
            this.InitModal(id).show();
        }
    }

    isShowedBootstrap(id: string) {
        return this.isShowBootstrap(id);
    }

    openOffcanvas(id: string) {
        openOffcanvas(id);
    }

    closeOffcanvas(id: string) {
        closeOffcanvas(id);
    }

    closeCollapse(id: string) {
        hideCollapse(id);
    }
}
